import { Component, OnInit, Input } from '@angular/core';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { Periode } from '../../../../models/periode.model';
import { Recette } from '../../../../models/recette.model';
import { ModificationRecetteComponent } from '../modificationRecette/modificationRecette.component';
@Component({
  selector: 'app-consulationRecetteDialog',
  templateUrl: './consulationRecetteDialog.component.html',
  styleUrls: ['./consulationRecetteDialog.component.scss']
})
export class ConsulationRecetteDialogComponent implements OnInit {
  @Input() recette: Recette;
  @Input() periodes: Periode[];
  constructor(protected ref: NbDialogRef<ConsulationRecetteDialogComponent>, private dialogService: NbDialogService) { }

  ngOnInit() {
  }


  dismiss() {
    this.ref.close();
  }

  modify(recette: Recette, periodes: Periode[]) {
    this.ref.close();
    this.dialogService.open(ModificationRecetteComponent, {
      context: {
        recette: recette,
        periodes: periodes,
      },
    });
  }

  counter(i: number) {
    return new Array(i);
  }
}
